import type { Stroke } from './types';

export const templateStrokes: Stroke[] = [
  {
    color: '#000',
    width: 2,
    path: [
      [299, 182],
      [295, 182],
      [291, 182],
      [287, 182],
      [283, 183],
      [279, 184],
      [275, 185],
      [272, 186],
      [269, 187],
      [266, 188],
      [263, 190],
      [260, 192],
      [257, 194],
      [254, 196],
      [251, 198],
      [248, 200],
      [245, 202],
      [243, 205],
      [240, 207],
      [237, 210],
      [234, 212],
      [232, 215],
      [229, 217],
      [227, 220],
      [224, 223],
      [221, 226],
      [219, 229],
      [216, 232],
      [214, 235],
      [213, 238],
      [212, 241],
      [211, 244],
      [210, 247],
      [208, 250],
      [207, 253],
      [206, 256],
      [204, 259],
      [203, 263],
      [202, 267],
      [202, 271],
      [200, 275],
      [199, 278],
      [199, 282],
      [198, 287],
      [197, 290],
      [196, 294],
      [195, 297],
      [194, 300],
      [193, 303],
      [192, 306],
      [192, 310],
      [192, 314],
      [192, 319],
      [192, 323],
      [192, 327],
      [192, 332],
      [192, 336],
      [192, 341],
      [193, 344],
      [194, 348],
      [194, 352],
      [195, 356],
      [196, 359],
      [197, 362],
      [198, 365],
      [198, 369],
      [199, 372],
      [199, 376],
      [200, 379],
      [201, 382],
      [203, 385],
      [205, 388],
      [207, 391],
      [209, 394],
      [210, 397],
      [213, 400],
      [215, 403],
      [217, 406],
      [219, 409],
      [222, 411],
      [224, 414],
      [227, 416],
      [230, 419],
      [233, 421],
      [236, 423],
      [239, 424],
      [242, 426],
      [245, 427],
      [248, 428],
      [251, 430],
      [254, 431],
      [257, 433],
      [260, 434],
      [263, 435],
      [266, 436],
      [269, 437],
      [274, 437],
      [277, 438],
      [281, 438],
      [285, 439],
      [289, 439],
      [293, 440],
      [297, 440],
      [301, 440],
      [305, 440],
      [309, 440],
      [313, 440],
      [317, 440],
      [321, 440],
      [324, 439],
      [327, 438],
      [330, 437],
      [333, 436],
      [336, 435],
      [340, 435],
      [343, 434],
      [346, 433],
      [349, 432],
      [352, 431],
      [355, 430],
      [358, 428],
      [361, 427],
      [364, 426],
      [367, 424],
      [370, 421],
      [373, 418],
      [376, 416],
      [378, 413],
      [381, 410],
      [383, 407],
      [386, 405],
      [388, 402],
      [389, 399],
      [391, 396],
      [392, 393],
      [394, 390],
      [396, 387],
      [397, 384],
      [399, 381],
      [400, 378],
      [401, 375],
      [402, 372],
      [403, 369],
      [404, 365],
      [405, 361],
      [405, 357],
      [406, 354],
      [406, 350],
      [406, 346],
      [407, 343],
      [407, 339],
      [407, 335],
      [407, 331],
      [407, 327],
      [407, 323],
      [407, 319],
      [407, 315],
      [407, 311],
      [407, 307],
      [406, 304],
      [406, 300],
      [405, 297],
      [404, 294],
      [403, 291],
      [402, 287],
      [402, 283],
      [401, 280],
      [400, 277],
      [399, 274],
      [398, 270],
      [398, 266],
      [397, 263],
      [396, 260],
      [395, 257],
      [394, 254],
      [392, 251],
      [391, 248],
      [388, 245],
      [387, 242],
      [385, 239],
      [384, 236],
      [383, 233],
      [382, 229],
      [381, 226],
      [379, 223],
      [376, 221],
      [373, 218],
      [370, 215],
      [367, 212],
      [364, 210],
      [361, 208],
      [359, 205],
      [356, 204],
      [354, 201],
      [351, 199],
      [348, 197],
      [345, 196],
      [342, 194],
      [339, 193],
      [336, 192],
      [333, 190],
      [330, 189],
      [327, 187],
      [324, 186],
      [321, 185],
      [317, 185],
      [314, 184],
      [310, 183],
      [306, 183],
      [303, 182],
      [299, 182]
    ]
  },
  {
    color: '#000',
    width: 1,
    path: [
      [324, 190],
      [320, 189],
      [317, 188],
      [314, 187],
      [311, 186],
      [308, 185],
      [304, 184],
      [300, 184],
      [296, 184],
      [292, 184],
      [288, 184],
      [284, 184],
      [280, 184],
      [276, 184],
      [273, 185],
      [270, 186],
      [267, 188],
      [264, 189],
      [261, 191],
      [258, 192],
      [255, 194],
      [252, 196],
      [249, 198],
      [246, 200],
      [243, 203],
      [240, 204],
      [237, 207],
      [236, 210],
      [233, 211],
      [231, 214],
      [228, 216],
      [225, 219],
      [222, 222],
      [219, 225],
      [217, 228],
      [215, 231],
      [214, 234],
      [212, 237],
      [211, 240],
      [209, 243],
      [208, 246],
      [207, 249],
      [206, 252],
      [205, 255],
      [203, 258],
      [202, 261],
      [200, 264],
      [199, 267],
      [199, 271],
      [198, 274],
      [197, 277],
      [197, 281],
      [196, 284],
      [195, 287],
      [194, 290],
      [193, 293],
      [192, 296],
      [192, 300],
      [191, 304],
      [191, 308],
      [191, 312],
      [192, 315],
      [192, 319],
      [193, 322],
      [193, 326],
      [194, 329],
      [194, 333],
      [195, 336],
      [195, 340],
      [196, 343],
      [196, 347],
      [197, 350],
      [197, 354],
      [197, 358],
      [197, 362],
      [198, 365],
      [198, 369],
      [199, 372],
      [200, 375],
      [201, 379],
      [202, 383],
      [203, 386],
      [206, 389],
      [208, 392],
      [210, 395],
      [213, 397],
      [215, 400],
      [218, 402],
      [219, 405],
      [221, 408],
      [223, 411],
      [225, 414],
      [228, 416],
      [231, 417],
      [233, 420],
      [235, 423],
      [237, 426],
      [240, 428],
      [243, 430],
      [246, 431],
      [249, 432],
      [252, 433],
      [255, 434],
      [258, 435],
      [261, 436],
      [265, 437],
      [268, 438],
      [272, 438],
      [275, 440],
      [279, 440],
      [283, 440],
      [287, 440],
      [291, 440],
      [295, 440],
      [298, 441],
      [302, 441],
      [306, 442],
      [310, 442],
      [314, 442],
      [317, 441],
      [321, 441],
      [325, 441],
      [328, 440],
      [331, 439],
      [334, 438],
      [337, 437],
      [340, 436],
      [344, 436],
      [347, 435],
      [350, 434],
      [353, 432],
      [356, 431],
      [359, 429],
      [362, 427],
      [365, 425],
      [368, 423],
      [371, 420],
      [374, 418],
      [376, 415],
      [379, 413],
      [381, 410],
      [384, 408],
      [387, 405],
      [389, 402],
      [391, 399],
      [394, 396],
      [396, 393],
      [397, 390],
      [398, 387],
      [400, 384],
      [401, 381],
      [402, 378],
      [403, 374],
      [403, 370],
      [404, 366],
      [405, 363],
      [406, 360],
      [407, 357],
      [408, 353],
      [408, 349],
      [408, 345],
      [409, 342],
      [409, 338],
      [409, 334],
      [410, 331],
      [410, 327],
      [410, 323],
      [409, 320],
      [409, 316],
      [409, 312],
      [409, 308],
      [408, 305],
      [408, 301],
      [408, 297],
      [407, 294],
      [406, 291],
      [405, 288],
      [404, 285],
      [404, 281],
      [403, 278],
      [402, 275],
      [401, 271],
      [400, 268],
      [399, 265],
      [399, 261],
      [397, 258],
      [395, 255],
      [393, 252],
      [392, 249],
      [391, 246],
      [389, 243],
      [388, 240],
      [387, 237],
      [386, 234],
      [384, 231],
      [382, 228],
      [381, 225],
      [379, 222],
      [377, 219],
      [374, 217],
      [372, 214],
      [370, 211],
      [367, 210],
      [364, 207],
      [361, 205],
      [358, 203],
      [356, 200],
      [353, 198],
      [350, 197],
      [347, 195],
      [344, 194],
      [341, 192],
      [337, 192],
      [334, 191],
      [330, 191],
      [326, 191],
      [323, 190]
    ]
  },
  {
    color: '#000',
    width: 2,
    path: [
      [262, 437],
      [262, 441],
      [262, 445],
      [262, 450],
      [262, 454],
      [262, 458],
      [262, 462],
      [262, 466],
      [262, 471],
      [262, 475],
      [262, 479],
      [262, 483],
      [262, 487],
      [262, 492],
      [262, 496],
      [262, 500],
      [262, 504],
      [262, 508],
      [262, 512],
      [262, 516],
      [263, 520],
      [263, 524],
      [263, 528],
      [263, 532],
      [266, 535],
      [269, 536],
      [273, 536],
      [276, 537],
      [280, 537],
      [283, 538]
    ]
  },
  {
    color: '#000',
    width: 1,
    path: [
      [332, 438],
      [332, 443],
      [332, 447],
      [332, 451],
      [332, 455],
      [332, 459],
      [332, 463],
      [332, 467],
      [332, 471],
      [332, 475],
      [332, 479],
      [332, 483],
      [333, 486],
      [333, 491],
      [333, 495],
      [333, 499],
      [333, 503],
      [333, 507],
      [333, 511],
      [333, 515],
      [333, 519],
      [334, 522],
      [334, 526],
      [334, 530],
      [334, 534],
      [337, 536],
      [340, 537],
      [343, 538],
      [347, 538],
      [351, 538],
      [354, 539]
    ]
  },
  {
    color: '#000',
    width: 1,
    path: [
      [260, 437],
      [260, 441],
      [260, 445],
      [260, 449],
      [261, 452],
      [261, 456],
      [261, 460],
      [261, 464],
      [261, 468],
      [261, 472],
      [262, 475],
      [262, 479],
      [262, 483],
      [262, 487],
      [262, 491],
      [262, 495],
      [262, 499],
      [262, 503],
      [262, 507],
      [262, 511],
      [262, 515],
      [262, 519],
      [262, 523],
      [262, 527],
      [262, 531],
      [262, 535],
      [266, 535],
      [269, 536],
      [272, 537],
      [276, 537],
      [279, 538],
      [283, 539]
    ]
  },
  {
    color: '#000',
    width: 2,
    path: [
      [333, 438],
      [333, 442],
      [333, 446],
      [333, 450],
      [333, 454],
      [333, 458],
      [333, 462],
      [333, 467],
      [333, 471],
      [333, 475],
      [333, 479],
      [333, 483],
      [333, 487],
      [334, 490],
      [334, 494],
      [334, 498],
      [333, 501],
      [333, 505],
      [333, 509],
      [333, 513],
      [333, 517],
      [334, 520],
      [334, 524],
      [333, 527],
      [333, 531],
      [333, 535],
      [336, 536],
      [340, 536],
      [343, 537],
      [347, 537],
      [350, 538],
      [354, 538],
      [358, 538]
    ]
  }
];
